<template>
<div class="report_custom page-content">
  <div class="content-header">
    <el-input
      class="search-input"
      v-model="custInfo"
      :placeholder="$t('Agent_Name_ID')"
      clearable
    ></el-input>
    <vs-button
      class="search-btn"
      @click="searchHandle"
    >{{$t('search')}}</vs-button>
  </div>
  <div class="vs-table-outer">
    <vs-table :noDataText="$t('root.noData')" :data="listData">
      <template
        slot="thead">
        <vs-th>
          {{$t('Agent_ID')}}
        </vs-th>
        <vs-th>
          {{$t('Agent_name')}}
        </vs-th>
        <vs-th>
          {{$t('mobile_phone')}}
        </vs-th>
        <vs-th>
          {{$t('email')}}
        </vs-th>
        <vs-th>
          {{$t('Agent_level')}}
        </vs-th>
        <vs-th>
          {{$t('customersNum')}}
        </vs-th>
        <vs-th>
          {{$t('Funds')}}
        </vs-th>
        <vs-th>
          {{$t('Certification_status')}}
        </vs-th>
        <vs-th>
          {{$t('Registration_time')}}
        </vs-th>
        <vs-th>
          {{$t('Trade.oper')}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data" >
          <vs-td>
            {{tr.id}}
          </vs-td>

          <vs-td>
            {{tr.userName}}
          </vs-td>

          <vs-td>
            {{tr.phone}}
          </vs-td>

          <vs-td>
            {{tr.email}}
          </vs-td>
          <vs-td>
            {{getLevel(tr)}}
          </vs-td>
          <vs-td>
            {{tr.totalNumber}}
          </vs-td>
          <vs-td>
            {{tr.totalBalance}}
          </vs-td>
          <vs-td>
            {{getStatus(tr)}}
          </vs-td>
          <vs-td>
            {{parseTime(tr.createTime)}}
          </vs-td>
          <vs-td>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('Modify_agent_level')"
              placement="top-center"
            >
              <i
                v-if="tr.modifyLevelFlag && tr.custType == 0"
                @click="editHandle(tr)"
                class="iconfont icon-edit-21 pointer"
              ></i>
            </el-tooltip>

          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
  <div class="pagination-outer" v-if="total">
    <div class="paginnation-left">
      <size-change
        @sizeChange="sizeChange"
      ></size-change>
      <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
  <edit-agent-level-dialog
    :dialog-show="editDialogShow"
    :ibList="ibList"
    :custId="currentCustId"
    :current-cust-lvl="currentCustLvl"
    @close="editDialogShow = false"
    @refrash="refrash"
  ></edit-agent-level-dialog>
</div>
</template>

<script>
import { querySubAgents, getAllSubRules } from '@/api/userCenter.js'
import editAgentLevelDialog from "@/components/agent/editAgentLevelDialog";
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index';

// 表格字段需要重新调 todo
import initData from "@/mixins/initData";

export default {
  name: "index",
  components: {
    editAgentLevelDialog
  },
  data() {
    return {
      custInfo: '',
      ibList: [],
      currentCustId: -1,
      currentCustLvl: -1,
      editDialogShow: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/partner/subIBList';
      this.params = {
        page: this.page -1,
        size: this.size,
        custId: this.userInfo.id,
        custType: 1,
      }
      if(this.custInfo){
        this.params.custInfo = this.custInfo;
      }
      return true;
    },
    belongHandle(row){
      if(!row.loginNumber){
        return;
      }
      this.$store.commit('setSubIbJumpToAccountListOfId', row.id);
      this.$router.push({
        name:'accountList'
      });
    },
    getLevel(tr){
      // 等级 白银 联调 todo
      return tr.levelName;
    },
    getStatus(row){
      switch (row.auditStatus) {
        case 0 || null:
          return this.$t('User.identifyStatus0');
        case 1:
          return this.$t('User.identifyStatus2');
        case 2:
          return this.$t('User.identifyStatus3');
        case 3:
          return this.$t('User.identifyStatus1');
        default:
          return this.$t('Authentication_failed');
      }
    },
    editHandle(row){
      this.currentCustId = row.id;
      this.currentCustLvl = row.levelId;
      if(!this.ibList.length){
        getAllSubRules({
          custId: this.userInfo.id,
        }).then((res) => {
          this.ibList = res.data;
          this.editDialogShow = true;
        })
      }else {
        this.editDialogShow = true;
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    refrash(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.report_custom {
  background-color: #ffffff;
}
</style>
